export const LUCID_FORMATTERS_MAP = {
    dates: {
        dateOnly: 'dateOnly',
        dateAndTime: 'dateAndTime',
        timeOnly: 'timeOnly',
    },
};
export const lucidFormatter = (value, formatting, lng) => {
    if (value instanceof Date) {
        const { dates } = LUCID_FORMATTERS_MAP;
        switch (formatting) {
            // ex. in english - Jun 25, 2024
            case dates.dateOnly:
                return value.toLocaleDateString(lng, {
                    day: 'numeric',
                    month: 'short',
                    year: 'numeric',
                });
            case dates.dateAndTime: {
                // Example: Oct 8, 2024 11:11
                const datePart = value.toLocaleDateString(lng, {
                    day: 'numeric',
                    month: 'short',
                    year: 'numeric',
                });
                const timePart = value.toLocaleTimeString(lng, {
                    hour: 'numeric',
                    minute: '2-digit',
                });
                return `${datePart} ${timePart}`;
            }
            // ex. in english - 11:11 AM
            case dates.timeOnly:
                return value.toLocaleTimeString(lng, {
                    hour: 'numeric',
                    minute: '2-digit',
                });
            // Ugliest possible date string, to remind
            // developers to pass the proper format string
            default:
                return value.toISOString();
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return -- i18n types
    return value;
};
// i18next 26 removed `interpolation.format`; named formats are registered on the
// formatter service, which i18next creates just before it inits external modules.
export const lucidFormattersModule = {
    type: '3rdParty',
    init: (instance) => {
        for (const format of Object.values(LUCID_FORMATTERS_MAP.dates)) {
            instance.services.formatter?.add(format, (value, lng) => lucidFormatter(value, format, lng));
        }
    },
};
